import { render } from "./S3Config.vue?vue&type=template&id=0529ab8d"
import script from "./S3Config.vue?vue&type=script&lang=js"
export * from "./S3Config.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__